const v = "5.7.5";
const fr = 100;
const ip = 0;
const op = 360;
const w = 60;
const h = 30;
const ddd = 0;
const layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "lottielab.com",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "el",
						d: 1,
						s: {
							a: 0,
							k: [
								11.87,
								11.87
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						}
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.016,
								0.451,
								0.92
							],
							ix: 2
						},
						o: {
							a: 1,
							k: [
								{
									t: 247,
									s: [
										0
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 252,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						r: 1,
						bm: 0
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									t: 252,
									s: [
										13.5,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 352,
									s: [
										46.44,
										15
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						}
					}
				]
			}
		],
		ip: 0,
		op: 361,
		st: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "el",
						d: 1,
						s: {
							a: 1,
							k: [
								{
									t: 14,
									s: [
										5.14,
										5.14
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 117,
									s: [
										11.87,
										11.87
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 252,
									s: [
										11.87,
										11.87
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 352,
									s: [
										5.14,
										5.14
									]
								}
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						}
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.22,
								0.824,
								0
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						},
						r: 1,
						bm: 0
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									t: 14,
									s: [
										30,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 117,
									s: [
										13.5,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 125,
									s: [
										13.5,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 240,
									s: [
										46.44,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 252,
									s: [
										46.44,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 352,
									s: [
										30,
										15
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						}
					}
				]
			}
		],
		ip: 0,
		op: 361,
		st: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "el",
						d: 1,
						s: {
							a: 1,
							k: [
								{
									t: 125,
									s: [
										12,
										12
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 240,
									s: [
										5,
										5
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 252,
									s: [
										5,
										5
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 352,
									s: [
										11.74,
										11.74
									]
								}
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						}
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.22,
								0.824,
								0
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						},
						r: 1,
						bm: 0
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									t: 5,
									s: [
										13.5,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 117,
									s: [
										46.5,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 125,
									s: [
										46.5,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 240,
									s: [
										30,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 252,
									s: [
										30,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 352,
									s: [
										13.5,
										15
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						}
					}
				]
			}
		],
		ip: 0,
		op: 361,
		st: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "el",
						d: 1,
						s: {
							a: 1,
							k: [
								{
									t: 5,
									s: [
										12,
										12
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 117,
									s: [
										5,
										5
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 125,
									s: [
										5,
										5
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 240,
									s: [
										11.87,
										11.87
									]
								}
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						}
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.016,
								0.451,
								0.92
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						},
						r: 1,
						bm: 0
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									t: 5,
									s: [
										46.5,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 117,
									s: [
										30,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 125,
									s: [
										30,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 240,
									s: [
										13.5,
										15
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 252,
									s: [
										13.5,
										15
									],
									o: {
										x: [
											0.4
										],
										y: [
											0
										]
									},
									i: {
										x: [
											0.8
										],
										y: [
											1
										]
									}
								},
								{
									t: 352,
									s: [
										46.44,
										15
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						}
					}
				]
			}
		],
		ip: 0,
		op: 361,
		st: 0
	}
];
const aniLtv110 = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	ddd: ddd,
	layers: layers
};

export { ddd, aniLtv110 as default, fr, h, ip, layers, op, v, w };
